
import {focus} from 'vue-focus'
import PullTo from 'vue-pull-to'
import {mapMutations} from 'vuex'
import {fetchResource, deleteFromCollection} from '@/api/resource'
import {formatNumInTenThousand} from '@/utils/index'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
data () {
return {
tabs: [
{
tabName: '软文',
navName: '软文推广',
tabType: 'news',
sortField: ['', 'price', 'pc_baidu_rank', 'm_baidu_rank', 'publish_rate'],
priceType: [],
priceTypeName: []
},
{
tabName: '微信',
navName: '微信营销',
tabType: 'woa',
sortField: ['', 'price', 'price_second', 'fan_num'],
priceType: ['top', 'non_top'],
priceTypeName: ['头条价', '非头条价']
},
{
tabName: '微博',
navName: '微博营销',
tabType: 'weibo',
sortField: ['', 'price', 'fan_num', 'avg_retweet_num', 'avg_like_num'],
priceType: ['tweet', 'retweet'],
priceTypeName: ['直发价', '转发价']
},
{
tabName: '网红',
navName: '网红直播',
tabType: 'live',
sortField: ['', 'price', 'fan_num'],
priceType: ['online', 'offline'],
priceTypeName: ['线上直播', '线下转发']
},
{
tabName: '短视频',
navName: '视频营销',
tabType: 'video',
sortField: ['', 'price', 'avg_play_num', 'fan_num'],
priceType: ['original_publish', 'publish'],
priceTypeName: ['原创发布', '发布']
}],
activeIndex: 0,
resourceData: []
}
},
components: {
PullTo,
Actionsheet,
Tab,
TabItem
},
directives: {
focus: focus
},
methods: {
...mapMutations({
setTitleVuex: 'SET_TITLE'
}),

tabClick (idx) {
this.activeIndex = idx
this.getDataByTab()
},

getDataByTab (type) {

this.resourceData = []
const tabType = this.tabs[this.activeIndex].tabType
fetchResource(tabType, {group_type: 'collect', per_page: 100}).then(resp => {
const resourceDataNew = resp.data.map((data) => {
const avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num)
const fansNum = formatNumInTenThousand(data.analysis.fans_num)
const avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num)
const price = formatNumInTenThousand(data.quote.price)
const priceSecond = formatNumInTenThousand(data.quote.price_second)
const cartStatus = data.cart && data.cart.created_at
const likeNum = formatNumInTenThousand(data.analysis.avg_like_num)
const priceBoxIsShow = false
return {
id: data.id,
avatar: data.avatar,
name: data.name,
cart: data.cart,
category: data.category,
analysis: data.analysis,
quote: data.quote,
description: data.description,
publish_rate: data.analysis.publish_rate,
remark: data.remark,
weight: data.weight,
taxonomy: data.taxonomy,
collectionId: data.collection.id,
avgReadNum,
fansNum,
avgPlayNum,
price,
priceSecond,
cartStatus,
priceBoxIsShow,
type,
likeNum
}
})
if (type === 'new') {
this.resourceData = this.resourceData.concat(resourceDataNew)
} else {
this.resourceData = resourceDataNew
}
}).catch((e) => console.log('error', e))
},
handleCancelCollect (data) {
const _this = this
this.$vux.confirm.show({
content: '确定取消收藏？',
onConfirm () {
deleteFromCollection(data.collectionId).then(resp => {
_this.$vux.toast.show({
text: resp.message
})
_this.getDataByTab()
}).catch((e) => {
})
}
})
},


getTabStatus () {

if (this.$route) {
this.activeIndex = 0
this.getDataByTab()
} else {
this.resourceData = []
}
}
},
beforeMount () {
this.getTabStatus()
}

}



// WEBPACK FOOTER //
// ./src/pages/collect/index.vue